import styled from 'styled-components';
import ds, { media } from 'designsystem';

const LanguagesDropdownWrapper = styled.div`
  ${media.desktop`
    display: block;
    line-height: ${ds.get('navSection.navHeight')};
    margin-left: calc(${ds.get('metrics.xs')} * 2);
  `}
`;

export default LanguagesDropdownWrapper;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Languages/LanguagesDropdownWrapper.jsx